export default __webpack_public_path__ + "static/media/city_shipping.51f71028.jpg";